/* eslint-disable */
import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';

const CestePutevi: IModel = {
  title: 'Ceste i putevi',
  apiPath: 'cestovna-infrastruktura/paths',
  layer: 'ceste_putevi',
  exportFileName: 'paths',
  forms: {
    default: {
      fields: [
        {source: 'id', width: 'full'},
        'path_label',
        'path_category_id',
        'path_surface_id',
        'path_status_id',
        'length',
        'comment'
      ],
    }
  },
  listViews: {
    default: {
      fields: [
        'id',
        'path_label',
        'path_category_id',
        'path_surface_id',
        'path_status_id',
        'length',
        'comment',
        'docs'
      ],
    },
    exportShp: {
      fields: [
        'id',
        'path_label',
        'path_category_id',
        'path_surface_id',
        'path_status_id',
        'length',
        'comment',
      ],
    },
    exportExcel: {
      fields: [
        'id',
        'path_label',
        'path_category_id',
        'path_surface_id',
        'path_status_id',
        'length',
        'comment',
      ],
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'category',
      source: 'path_category_id',
      ttoken: 'core:common.category',
      type: 'picker',
      subModel: {
        apiPath: 'cestovna-infrastruktura/path-categories',
        format: '{label}',
        idattr: 'id'
      },
      translate: true,
      filter: true,
      readonly: true,
    },
    {
      title: 'surface',
      source: 'path_surface_id',
      ttoken: 'cestovna_infrastruktura:ceste_putevi.povrsina',
      type: 'picker',
      subModel: {
        apiPath: 'cestovna-infrastruktura/path-surfaces',
        format: '{label}',
        idattr: 'id'
      },
      translate: true,
      filter: true,
      readonly: true,
    },
    {
      title: 'status',
      source: 'path_status_id',
      ttoken: 'core:common.status',
      type: 'picker',
      subModel: {
        apiPath: 'cestovna-infrastruktura/path-statuses',
        format: '{label}',
        idattr: 'id'
      },
      translate: true,
      filter: true,
      readonly: true,
    },
    {
      title: 'label',
      source: 'path_label',
      ttoken: 'cestovna_infrastruktura:ceste_putevi.oznaka',
      type: 'text',
      readonly: true,
      filter: true,
    },
    {
      title: 'comment',
      source: 'comment',
      ttoken: 'core:common.comment',
      type: 'multiline',
      rows: 2,
      maxRows: 3,
      width: 'full',
      validation: {
        required: true,
      },
      readonly: true,
    },
    {
      title: 'length',
      source: 'length',
      ttoken: 'cestovna_infrastruktura:ceste_putevi.duljina',
      type: 'numeric',
      readonly: true,
      filter: true,
    },
    {
      title: 'Geometry',
      source: 'geom',
      ttoken: 'common.geometry',
      type: 'wkt',
      sourceProjection: 'EPSG:3857',
      targetProjection: 'EPSG:3857',
      readonly: true,
    },
    coreFields.gid,
    coreFields.docs,
    coreFields.created_by,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on
  ],
};

export default CestePutevi;
